import { render, staticRenderFns } from "./SettingsHome.vue?vue&type=template&id=2409a366&"
import script from "./SettingsHome.vue?vue&type=script&lang=js&"
export * from "./SettingsHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports